
import {
  Component, Mixins, Prop,
} from 'vue-property-decorator';
import moment from 'moment';
import PlanMixin from '@/mixins/PlanMixin.vue';
import { Connection } from '@/types';
import EditConnectionPlanDialog from '@/components/connections/EditConnectionPlanDialog.vue';
import UtilsMixin from '@/mixins/UtilsMixin.vue';

moment.locale('it');

@Component({
  components: {
    EditConnectionPlanDialog,
  },
})
export default class ConnectionPlan extends Mixins(PlanMixin, UtilsMixin) {
  @Prop(Object) readonly connection!: Connection;

  loading = false
  editDialog = false

  get isDisabled() {
    // L'editing è disabilitato per chi non ha i permessi di modifica degli allegati
    // di tipo progettoElettrico
    return this.loading
      || (!this.hasPermission('attachments.progettoElettrico.add')
      && !this.hasPermission('attachments.progettoElettrico.delete'));
  }

  get planTaskStatus(): string {
    return this.connection?.planTaskStatus || '';
  }

  get pTooltipColor(): string {
    return this.connection ? this.tooltipColor(this.connection?.planStatus) : '';
  }

  get pChipOutlined(): boolean {
    return this.connection ? this.chipOutlined(this.connection?.planStatus) : false;
  }

  get pChipColor(): string {
    if (this.loading) return 'grey';
    return this.connection ? this.chipColor(this.connection?.planStatus) : '';
  }

  get hasP(): boolean {
    return this.connection?.planStatus === 'done' || this.connection?.planStatus === 'na';
  }

  get pHasNotes(): boolean {
    return this.connection?.hasPlanNotes === true;
  }

  get supplyLabel(): string | null {
    return this.connection && 'supplyLabel' in this.connection ? this.connection.supplyLabel : null;
  }

  get powerDetails1(): string | null {
    return this.connection && 'powerDetails1' in this.connection ? this.connection.powerDetails1 : null;
  }

  get powerDetails2(): string | null {
    return this.connection && 'powerDetails2' in this.connection ? this.connection.powerDetails2 : null;
  }

  get powerDetails3(): string | null {
    return this.connection && 'powerDetails3' in this.connection ? this.connection.powerDetails3 : null;
  }

  get powerDetails4(): string | null {
    return this.connection && 'powerDetails4' in this.connection ? this.connection.powerDetails4 : null;
  }

  get powerDetails5(): string | null {
    return this.connection && 'powerDetails5' in this.connection ? this.connection.powerDetails5 : null;
  }

  get pTooltipText(): string {
    let text = this.connection ? this.tooltipText('Progetto', this.connection?.planStatus) : 'Progetto';
    text = `<strong>${text}</strong>`;

    if (this.supplyLabel === 'Fornitura definitiva') {
      if (this.powerDetails1) text += `<br>Potenza Moduli FV/Campo FV [kWp]: ${this.powerDetails1}`;
      if (this.powerDetails2) text += `<br>Potenza Inverter [kW]: ${this.powerDetails2}`;
      if (this.powerDetails3) text += `<br>Potenza batteria lato AC [kW]: ${this.powerDetails3}`;
      if (this.powerDetails4) text += `<br>Potenza ai fini della conness. (P nom.) [kW]: ${this.powerDetails4}`;
      if (this.powerDetails5) text += `<br>Potenza ai fini della conness. (P imm.) [kW]: ${this.powerDetails5}`;
    }

    return text;
  }

  get columnClass(): string {
    if (this.planTaskStatus === 'completed') return 'green';
    if (this.planTaskStatus === 'error') return 'red';
    if (this.hasP) return 'green';
    return '';
  }

  // Azioni

  async onEdit() {
    // Non permette l'apertura del dialog durante il caricamento
    if (this.isDisabled || this.isConnectionLoading || this.currentConnection !== null) return;

    console.log(`${this.constructor.name}: onEdit()`); // eslint-disable-line no-console

    // La connessione deve esistere per procedere
    if (this.connection) {
      // Seleziona la Connection prima di aprire il dialog
      this.loading = true;
      await this.$store.dispatch('selectConnection', { id: this.connection.id });
      this.editDialog = true;
      this.loading = false;
    }
  }
}
